import { Injectable } from '@angular/core';
import { HttpService } from '../common/utils/http.service';
import { BOBCAT_API } from '../common/utils/api.bobcat';
import { LoginService } from './login/login.service';
import { DocumentService } from './document.service';

import { Store } from '@ngrx/store';
import * as fromRoot from '../common/appstore/index';
import * as layout from '../common/appstore/actions';

export const api = BOBCAT_API;

@Injectable()
export class GenericService {

  constructor(
    private httpservice: HttpService,
    private loginservice: LoginService,
    private documentservice: DocumentService,
    private store: Store<fromRoot.AppState>
  ) { }

  get servicehttp() {
    return this.httpservice;
  }

  get currentuser() {
    return this.loginservice.getUser();
  }

  get currentdocument() {
    return this.documentservice.currentdocument;
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/generic.service.ts